import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=7b6cc0a6&scoped=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"
import style0 from "./CurrencyInput.vue?vue&type=style&index=0&id=7b6cc0a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6cc0a6",
  null
  
)

export default component.exports